function updateBundleAvailability(component) {
  const productId = component.dataset.productId;
  const product = getBundleProduct(productId);
  if (!product) return;

  const variants = product.variants;
  const optionNames = product.options; // ["Colour", "Size"]

  // Detect which option is colour and which is size
  let colourIndex = null;
  let sizeIndex = null;

  optionNames.forEach((name, i) => {
    const lower = name.toLowerCase();
    if (lower.includes('colour') || lower.includes('color'))
      colourIndex = i + 1;
    if (lower.includes('size')) sizeIndex = i + 1;
  });

  // Safety fallback: if detection fails, assume option1 = colour, option2 = size
  if (!colourIndex) colourIndex = 1;
  if (!sizeIndex) sizeIndex = 2;

  const colourGroup = component.querySelector(
    `.product__variant-pills[data-option-position="${colourIndex}"]`
  );

  const sizeGroup = component.querySelector(
    `.product__variant-pills[data-option-position="${sizeIndex}"]`
  );

  const activeColour = colourGroup
    ? colourGroup.querySelector('.active')?.dataset.value || null
    : variants[0][`option${colourIndex}`];

  const activeSize = sizeGroup
    ? sizeGroup.querySelector('.active')?.dataset.value || null
    : variants[0][`option${sizeIndex}`];

  // Find all colours available for this size
  const availableColoursForSize = variants
    .filter(
      v => v[`option${sizeIndex}`] === activeSize && v.available
    )
    .map(v => v[`option${colourIndex}`]);

  let finalColour = activeColour;

  // If the current colour is not available for this size → fallback
  if (
    colourGroup &&
    !availableColoursForSize.includes(activeColour)
  ) {
    finalColour = availableColoursForSize[0];

    colourGroup.querySelectorAll('button').forEach(btn => {
      btn.classList.toggle(
        'active',
        btn.dataset.value === finalColour
      );
    });
  }

  if (colourGroup) {
    colourGroup.querySelectorAll('button').forEach(btn => {
      const val = btn.dataset.value;
      btn.classList.toggle('btn-disabled', !availableColoursForSize.includes(val));
    });
  }

  // if all the values for an option are disabled, disable the add to cart button
  if (colourGroup) {
    const buttons = Array.from(colourGroup.querySelectorAll('button'));
    const allDisabled = buttons.every(btn => btn.classList.contains('btn-disabled'));
    if (allDisabled) {
      const atcBtn = document.querySelector('.product__buttons .button');
      if (atcBtn) {
        atcBtn.classList.add('btn-disabled');
        atcBtn.setAttribute('disabled', true);
        atcBtn.innerHTML = 'Sold Out';
      }
    }
  }

  // Sizes are NEVER disabled — so we leave sizeGroup untouched

  // Resolve correct variant
  const finalVariant = variants.find(
    v =>
      v[`option${colourIndex}`] === finalColour &&
      v[`option${sizeIndex}`] === activeSize &&
      v.available
  );

  // Update hidden variant ID
  if (finalVariant) {
    component.querySelector('.bundle-selected-variant').value =
      finalVariant.id;

    const componentIndex = component.dataset.componentIndex;
    const modal = document.querySelectorAll('.engraving-modal')[
      componentIndex - 1
    ];
  }
}

function getBundleProduct(id) {
  const el = document.querySelector(`#bundleProduct-${id}`);
  return el ? JSON.parse(el.textContent) : null;
}

function bundleSelectOption(button) {
  const group = button.closest('.product__variant-pills');
  if (!group) return;

  const comp = button.closest('.bundle-component');
  const productId = comp.dataset.productId;

  group
    .querySelectorAll('button')
    .forEach(b => b.classList.remove('active'));
  button.classList.add('active');

  // Update selected text in the title
  const variantBox = group.closest('.product__variant');
  const selectedValueEl = variantBox.querySelector('.selected-value');
  if (selectedValueEl) {
    selectedValueEl.textContent = button.dataset.value;
  }

  updateBundleAvailability(comp);

  const variant = button.dataset.valueId;

  // const chosen = [];
  // comp.querySelectorAll('.product__variant-pills').forEach(g => {
  //   const active = g.querySelector('.active');
  //   chosen.push(active ? active.dataset.value : '');
  // });

  // const data = getBundleProduct(productId);
  // if (!data) {
  //   return;
  // }

  // const variant = data.variants.find(
  //   v =>
  //     v.option1 === chosen[0] &&
  //     (!v.option2 || v.option2 === chosen[1]) &&
  //     (!v.option3 || v.option3 === chosen[2])
  // );

  if (variant) {
    comp.querySelector('.bundle-selected-variant').value = variant;
  }

  updateBundleComponentsProperty();
}

document.addEventListener('DOMContentLoaded', () => {
  document
    .querySelectorAll('.bundle-component')
    .forEach(component => {
      // Click the first active pill for each option group (simulates selection)
      component
        .querySelectorAll('.product__variant-pills')
        .forEach(group => {
          const firstBtn = group.querySelector('button.active');
          if (firstBtn) {
            firstBtn.click(); // triggers JS logic to update selected-value + hidden fields
          }
        });
    });

  updateBundleComponentsProperty();
});

function updateBundleComponentsProperty() {
  const ids = [];
  const components = [];

  document
    .querySelectorAll('.bundle-component .bundle-selected-variant')
    .forEach(input => {
      if (!input.value) return;

      const variantId = String(input.value);
      ids.push(`gid://shopify/ProductVariant/${variantId}`);

      // If you have per-component quantity, read it here. Otherwise default to 1.
      const componentEl = input.closest('.bundle-component');
      const qty =
        parseInt(componentEl?.querySelector('[name="quantity"]')?.value, 10) || 1;

      components.push({ variantId, quantity: qty });
    });

  const bundleInput = document.getElementById('bundle-components');
  if (bundleInput) {
    bundleInput.value = JSON.stringify(ids);
  }

  // Expose for Meta bundle tracking
  window.bundleComponents = components;

  // Bundle total price (minor units). Use a reliable source if you have one in DOM.
  // Example: a hidden input you control, or a price element with cents on dataset.
  const totalEl = document.querySelector('[data-bundle-total-cents]');
  const totalCents = totalEl ? parseInt(totalEl.getAttribute('data-bundle-total-cents'), 10) : 0;
  window.bundleTotalPrice = Number.isFinite(totalCents) ? totalCents : 0;
}

document
  .getElementById('bundle-form')
  ?.addEventListener('submit', () => {
    updateBundleComponentsProperty();
  });
